// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ddd41c7d","977":"5c5e4f1c"}[chunkId] + ".chunk.js";
};